import { Platform } from 'react-native';
import styled from 'styled-components/native';

import Button from 'components/Button';

export default styled(Button)`
  width: ${Platform.OS === 'web' ? `70%` : '100%'};
`;
